import ErrorBox from './ErrorBox'

export default ErrorBox
